import React, { useMemo } from 'react'
import { useQuery } from 'jsonapi-react'
import Slider from 'app/theme/slider'
import styles from './RecentActivations.module.css'
import { getResizedPhotoUrl } from 'app/utils/photos'

export default function RecentActivations(props) {
  const { case_study_tags } = props

  const query = useQuery(['case_studies', {
    sort: '-id',
    filter: {
      active: true,
      tags: case_study_tags,
    },
    include: [
      'photos'
    ],
  }])

  const activations = useMemo(() => {
    return query.data?.length ? query.data : []
  }, [query.data])

  if (!activations.length) {
    return null
  }

  return (
    <div className="container my-12">
      <h2 className="text-3xl text-navy text-center font-platform mb-6">Case Studies</h2>
      <p className="font-light text-lg text-center pb-5">
        Just a few of the brands we’ve worked with in the past decade to create branded
        food truck promotions and mobile experiential tours.
      </p>
      <Slider
        arrows={true}
        dots={true}
        slidesToShow={2}
        slidesToScroll={2}
        className={styles.case_study_slider}
        responsive={[{
          breakpoint: 768,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }]}
      >
        {activations.map(activation => (
          <div key={activation.id} className="md:p-10 mb-16 w-full lg:w-4/6 mx-auto">
            {activation.photos.length > 0 && (
              <img
                src={getResizedPhotoUrl(activation.photos[0], 1024, 1024)}
                className={[
                  styles.activation_img,
                  'w-full mx-auto object-cover mb-8',
                ]}
              />
            )}
            <p className="font-semibold uppercase text-black text-center tracking-widest truncate">
              {activation.title}
            </p>
            <a
              className="inline-block w-full text-center leading-none text-blue text-4xl pb-1 mb-4 hover:underline truncate"
              href={`/experiential-marketing-agency/${activation.slug}/`}
            >
              {activation.product}
            </a>
            <p
              className="text-lg leading-relaxed font-national text-left font-light mb-6 overflow-hidden"
              style={{maxHeight: "200px", height: "200px"}}
              dangerouslySetInnerHTML={{ __html: activation.intro }}
            />
            <div className="flex items-center justify-center">
              <hr className="m-5 flex-grow"></hr>
              <a
                href={`/experiential-marketing-agency/${activation.slug}/`}
                className={[
                  styles.activation_read,
                  'btn py-1 px-4 border-solid border-1 border border-gray-400 text-gray-600 bg-gray-100 hover:bg-gray-500 hover:border-transparent hover:text-white',
                ]}
              >
                Read More
              </a>
              <hr className="m-5 flex-grow"></hr>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}
